import http from '@/assets/common/http';
// 拉取DS订单列表
export function DSOrderFun(data) {
  const params = {
    SERVICE_ID: '10179',
    OTYPE: 8,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取DS订单详情
export function DSOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '10034',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// 新拉取DS订单详情
export function newDSOrderDetailFun(data) {
  const params = {
    SERVICE_ID: '10179',
    OTYPE: 14,
    ...data,
  };
  return http.post(params);
}
// 转换待确认
export function changeStatusFun(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取客户列表
export function queryCustomerFun(data) {
  const params = {
    SERVICE_ID: '10009',
    OTYPE: 15,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取供应商列表
export function haveSupplierFun(data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改DS订单
// 导入门店价格

// 验收
export function checkOrder(data) {
  const params = {
    SERVICE_ID: '10179',
    OTYPE: 6,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function 订单查询(data) {
  const params = {
    SERVICE_ID: '10179',
    OTYPE: 89,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: Number(sessionStorage.getItem('userId')),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
export function 拉取订单详情(data) {
  const params = {
    SERVICE_ID: '10179',
    OTYPE: 14,
    // GYS_ID: Number(sessionStorage.getItem('tcId')),
    USER_ID: Number(sessionStorage.getItem('userId')),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/DSOrder.js